import React from 'react';
import { withRouter, matchPath } from 'react-router-dom';
import { AppCollection } from '../../services/collection';

class CurrentApplicationLabel extends React.Component {

  getName() {
    const match = matchPath(this.props.location.pathname, {
      path: '/applications/:uuid/',
      exact: false
    });
    if (!(match && match.params.uuid)) {
      return '';
    }
    const found = (this.props.apps || [])
      .find(({ uuid }) => uuid === match.params.uuid);
    return (found ? found.name : null) || '';
  }

  render() {
    return <React.Fragment children={this.getName()} />;
  }

}

const mapAppProps = ({ loading, list }) => ({ apps: list, appsLoading: loading });

const appConnect = AppCollection.connect(mapAppProps);

export default withRouter(appConnect(CurrentApplicationLabel));



// WEBPACK FOOTER //
// ./src/app/applications/current-label.js